import { useSelector, useDispatch } from 'react-redux';
import { setData as setDispatch } from '../../core/redux/app/Actions';
import { useCompanies } from '../../core/hooks/useCompanies';
import FinancialDashboardScreen from '../../screens/FinancialDashboard/FinancialDashboardScreen.jsx';

const FinancialDashboardContainer = () => {
  const company = useSelector((state) => state.app.company || {});
  const dispatch = useDispatch();
  const { companies, loading } = useCompanies();

  const changeCompany = (comp) => {
    if (comp && comp.id) {
      dispatch(setDispatch({ company: comp }));
    }
  };

  return (
    <FinancialDashboardScreen
      companies={companies}
      selectedCompany={company}
      changeCompany={changeCompany}
      loading={loading}
    />
  );
};

export default FinancialDashboardContainer;
